import { Button, RegularButtonProps } from '@/components/button';
import { ACCEPTED_FILE_TYPES, ACCEPTED_IMAGE_TYPES } from '@/util/constants';
import clsx from 'clsx';
import { useRef } from 'react';
import styles from './file-input.module.css';

type AcceptType = 'images' | 'files';
export interface FileInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'accept'
> {
  buttonProps?: Omit<RegularButtonProps, 'onClick'>;
  onFilesSelected: (files: File[]) => void;
  acceptType?: AcceptType;
}

export function FileInput({
  acceptType = 'images',
  onFilesSelected,
  buttonProps,
  ...restProps
}: FileInputProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const preventRefreshing = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      onFilesSelected(Array.from(event.target.files));
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        hidden
        style={{ display: 'none' }}
        accept={getAcceptedFileTypes(acceptType)}
        onChange={(e) => {
          preventRefreshing(e);
          handleFileChange(e);
        }}
        onInput={preventRefreshing}
        {...restProps}
      />
      <Button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        className={clsx(styles.button, buttonProps?.className)}
        {...buttonProps}
      >
        {buttonProps?.children}
      </Button>
    </>
  );
}

function getAcceptedFileTypes(acceptType: AcceptType) {
  return acceptType === 'images' ? ACCEPTED_IMAGE_TYPES : ACCEPTED_FILE_TYPES;
}
